import React from 'react';
import AddSpecModal, { SpecType } from './AddSpecModal';
import { usePackCopyContext } from '../contexts/PackCopyContext';

interface AddSpecModalWithContextProps {
    onClose: () => void;
    onNext: (
        specType: SpecType,
        specNameValue: string,
        specNameLabel: string,
    ) => void;
    initialSpecType?: SpecType | null;
    initialSpecNameValue?: string;
}

const AddSpecModalWithContext: React.FC<AddSpecModalWithContextProps> = (
    props,
) => {
    const {
        state: {
            packCopyDetailed: { specs },
        },
    } = usePackCopyContext();

    const existingSpecNames = specs.map((spec) => spec.name);

    return <AddSpecModal {...props} existingSpecNames={existingSpecNames} />;
};

export default AddSpecModalWithContext;
